<template>
  <main-page :user="user" color="orange">
    <template v-slot:title>
      <template v-if="prototype"> UPLOAD PROTOTYPE </template>
      <template v-else> UPLOAD PITCH </template>
    </template>

    <div class="container">
      <div v-if="team" class="row content">
        <div v-if="!selectedAssignment" class="col-12">
          <div class="mx-auto d-flex flex-column" style="max-width: 500px">
            <h3 class="flex-grow text-left si-font my-1 pb-0">Select an Assignment</h3>
            <div
              v-for="pa in pitchAssignments"
              :key="pa.id"
              class="card mt-2 p-1 w-100 black-border"
              :class="{
                'text-muted': !pa.withinWindow && user.role != 'TEACHER',
              }"
            >
              <div class="d-flex flex-row align-items-center px-2">
                <div class="flex-grow">
                  <div class="flex-grow text-left text-md">
                    {{ pa.name }}
                  </div>
                  <template v-if="pa.pitch">
                    <div class="mb-0 text-muted text-left">Uploaded:</div>
                    <div class="mb-1 text-muted text-left" style="line-height: 1">
                      {{ fs.shortDate(pa.pitch.created_at) }}
                    </div>
                  </template>
                  <div class="mb-0 text-muted text-left">Available:</div>
                  <div class="mb-1 text-muted text-left" style="line-height: 1">
                    {{ fs.shortDate(pa.start) }} to {{ fs.shortDate(pa.end) }}
                  </div>
                </div>
                <template v-if="pa.pitch">
                  <button
                    v-if="(pa.withinWindow && pa.feedbackCount == 0) || user.role == 'TEACHER'"
                    class="btn btn-no-border btn-si-yellow btn-same-width"
                    @click="chooseAssignment(pa)"
                  >
                    Re-upload...
                  </button>
                  <button
                    v-if="(!pa.withinWindow || pa.feedbackCount > 0) && user.role != 'TEACHER'"
                    class="btn btn-no-border btn-si-gray btn-same-width"
                    disabled
                  >
                    Uploaded
                  </button>
                </template>
                <template v-if="!pa.pitch">
                  <button
                    v-if="!pa.withinWindow && user.role != 'TEACHER'"
                    class="btn btn-no-border btn-si-gray btn-same-width"
                    disabled
                  >
                    Unavailable
                  </button>
                  <button
                    v-if="pa.withinWindow || user.role == 'TEACHER'"
                    class="btn btn-no-border btn-si-green btn-same-width"
                    @click="chooseAssignment(pa)"
                  >
                    Upload...
                  </button>
                </template>
                <template v-if="pa.pitch && user.role == 'TEACHER'">
                  <button
                    class="btn btn-no-border btn-si-orange btn-same-width ml-2"
                    @click="openDeletePitchModal(pa)"
                  >
                    Delete
                  </button>
                </template>
              </div>
            </div>
          </div>
          <div
            v-if="!(pitchAssignments && pitchAssignments.length > 0)"
            class="text-center text-very-muted text-lg _800 mt-2"
          >
            No Assignments
          </div>
        </div>
        <div v-if="selectedAssignment" class="col-12">
          <h2 class="flex-grow text-left si-font mt-1 mb-3 pb-0">
            <span>{{ selectedAssignment.name }}</span>
          </h2>
          <div class="card shadow-sm" style="width: 100%; margin: 10pt 0pt">
            <div
              class="px-3 py-1 text-lg si-font si-blue text-white text-left _600 clickable d-flex flex-row align-items-center"
              @click="toggleInstructions"
            >
              <div class="flex-grow">Instructions</div>
              <i
                class="fas fa-caret-down anim-rotate"
                :class="{ 'fa-rotate-90': hideInstructions }"
              />
            </div>
            <div
              v-if="!hideInstructions"
              class="card-body p-3"
              style="text-align: left"
              v-html="instructions"
            ></div>
          </div>
          <!-- Description box -->
          <RichText
            v-if="prototype"
            :text.sync="descriptionText"
            :options="{
              height: 104,
              toolbar: [
                ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
              ],
              placeholder: 'Prototype description',
            }"
          />
          <!-- Upload file -->
          <Uploader
            v-show="uploadFrom == 'computer'"
            :error="uploadError"
            :complete="uploadComplete"
            :upload.sync="submitUpload"
            :acceptedFiles="prototype ? null : '.mp4,.mov'"
            v-on:file="updateFile"
            class="black-border"
          ></Uploader>
          <!-- <vue-dropzone
						v-show="uploadFrom == 'computer'"
						ref="myVueDropzone"
						id="dropzone"
						class="h-100"
						:options="dropzoneOptions"
						@vdropzone-sending="sendingEvent"
						:useCustomSlot="true"
						@vdropzone-error="dropzoneError"
						@vdropzone-queue-complete="finished"
						@vdropzone-files-added="removeIfUnsupported"
					>
						<div class="dropzone-custom-content">
							<i class="fas fa-file-alt fa-5x mb-4" />
							<h3 class="dropzone-custom-title">
								Drag and drop to upload content
							</h3>
							<div class="subtitle">
								...or click/tap to select a file from your computer/device
							</div>
						</div>
					</vue-dropzone> -->

          <!-- YouTube URL -->
          <div v-if="uploadFrom == 'youtube'" class="card px-4 pb-4 pt-2 black-border">
            <label class="si-font large-label" style="font-size: 40px"
              >Enter YouTube URL:</label
            >
            <input
              class="form-control text-center black-border youtube-url-entry"
              :class="{
                'is-invalid': youTubeURL && !youTubeID,
                'is-valid': youTubeURL && youTubeID,
              }"
              v-model="youTubeURL"
            />
            <div v-if="youTubeID" class="video-box">
              <iframe
                width="560"
                height="315"
                :src="`https://www.youtube.com/embed/${youTubeID}`"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>

          <div class="box-footer mt-3 pt-0 px-0 d-flex flex-row">
            <button class="btn btn-no-border btn-si-blue mr-3" data-toggle="dropdown">
              Upload From...
              <i class="fas fa-caret-up fa-fw" />
            </button>
            <div class="dropdown-menu dropdown-menu-left">
              <a
                class="dropdown-item d-flex flex-row align-items-center"
                @click="uploadFrom = 'computer'"
                :class="{ active: uploadFrom == 'computer' }"
              >
                <i class="fas fa-lg fa-window"></i>
                <div class="mb-0">My files</div>
              </a>
              <a
                class="dropdown-item d-flex flex-row align-items-center"
                @click="uploadFrom = 'youtube'"
                :class="{ active: uploadFrom == 'youtube' }"
              >
                <i class="fas fa-lg fa-window"></i>
                <div class="mb-0">YouTube</div>
              </a>
            </div>
            <button
              v-if="!submitting"
              @click="submit()"
              class="btn btn-no-border btn-si-green flex"
            >
              Submit
            </button>
            <button v-if="submitting" class="btn si-btn-green text-white flex" disabled>
              Submitting...
              <loading type="icon" />
            </button>
          </div>
        </div>
      </div>
      <div v-if="!team && user.role != 'TEACHER'">
        <h1 class="text-extra-muted mt-5" style="font-size: 64px">No Team</h1>
        <h3 class="text-extra-muted">
          You must be on a team in this class to upload a
          {{ prototype ? "prototype" : "pitch" }}.<br />Please contact your teacher to put
          you on a team.
        </h3>
      </div>
      <div v-if="!team && user.role == 'TEACHER'" class="row content">
        <div class="col-12">
          <div class="mx-auto d-flex flex-column" style="max-width: 500px">
            <h3 class="flex-grow text-left si-font my-1 pb-0">Select a Team</h3>
            <div
              v-for="t in context.teams"
              :key="t.id"
              class="card mt-2 p-1 w-100 black-border"
            >
              <div class="d-flex flex-row align-items-center px-2">
                <div class="flex-grow">
                  <div class="flex-grow text-left text-md">
                    {{ t.name }}
                  </div>
                  <div
                    class="mb-1 text-muted text-left"
                    style="line-height: 1; height: 1.8rem"
                  >
                    {{ fs.listNames(t.students) }}
                  </div>
                </div>
                <button
                  class="btn btn-no-border btn-si-green btn-same-width"
                  @click="selectTeam(t)"
                >
                  Select
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete pitch modal -->
    <b-modal id="deletePitchModal" headerClass="indigo">
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">Delete Pitch</h3>
      </template>
      <div v-if="deletingPitch && team" class="p-2">
        <div class="row px-4 py-2 text-md">
          <h5 class="py-2">
            Are you sure you want to delete the pitch
            <strong class="text-theme text-center">{{ deletingPitch.name }}</strong>
            for team
            <strong class="text-theme text-center">{{ team.name }}</strong>?
          </h5>
          <h6 class="py-2">
            <span class="text-danger far faw fa-exclamation-triangle"></span>
            The operation will occur immediately and cannot be canceled or reversed!
          </h6>
            <label class="md-check check-md">
              <input type="checkbox" v-model="deleteFeedbacks" />
              <i class="blue"></i> Delete Pitch Feedbacks
            </label>
          <h6 class="py-2" v-if="deleteFeedbacks">
            <span class="text-danger far faw fa-exclamation-triangle"></span>
            This will permanently delete all feedback associated with the pitch!
          </h6>
        </div>
        <div class="form-group pl-2 pr-3">
          <input type="text" v-model="deleteConfirm" class="form-control" />
          <small class="text-muted">To confirm, type "{{ deletingPitch.name }} {{ team.name }}"</small>
        </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
        <button
          type="button"
          class="btn btn-danger"
          :disabled="deleteConfirm != deletingPitch.name + ' ' + team.name"
          @click="deletePitch(deletingPitch, ok)"
        >
          Delete
        </button>
      </template>
    </b-modal>

    <template v-slot:footer>
      <div class="col-6 text-right">
        <button
          v-if="selectedAssignment || (user.role == 'TEACHER' && team)"
          class="btn btn-si-secondary mr-3"
          @click="goBack"
        >
          Back
        </button>
        <a
          v-else
          class="btn btn-si-secondary mr-3"
          :href="prototype ? '#/prototype_entry' : '#/pitch_entry'"
        >
          Back
        </a>
      </div>
    </template>
  </main-page>
</template>

<script>
var unsupportedMTs = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/csv",
];

import SectionService from "@/services/SectionService";
import PitchService from "@/services/PitchService";
import ProgramService from "@/services/ProgramService";

import TeamService from "@/services/TeamService";
import MainPage from "@/components/MainPage";
import Uploader from "@/components/Uploader";
import RichText from "@/components/RichText";

import Notie from "@/services/NotieService";
import BB from "bluebird";
import fs from "@/services/FormatService";
import _ from "lodash";

export default {
  name: "UploadPitch",

  props: ["user"],

  components: { MainPage, Uploader, RichText },

  data() {
    var prototype = false;
    if (this.$route.path == "/upload_prototype") {
      prototype = true;
    }

    return {
      fs: fs,

      context: null,
      pitchAssignments: [],
      selectedAssignment: null,
      pitches: null,
      team: null,

      uploadFrom: "computer",
      submitting: false,
      youTubeURL: null,
      submitUpload: null,
      file: null,
      uploadKeys: null,

      instructions: null,
      hideInstructions: false,
      descriptionText: "",

      prototype: prototype,

      deletingPitch: null,
      deleteConfirm: null,
      deleteFeedbacks: false,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    youTubeID() {
      if (!this.youTubeURL) {
        return null;
      }
      return this.getYouTubeID(this.youTubeURL);
    },

/*
    uploadEndpoint() {
      if (!(this.team && this.selectedAssignment)) {
        return "";
      }
      return `/v1/pitch/chunk/${this.team.id}/${this.selectedAssignment.id}`;
    },
  */
  },

  methods: {
    loadData() {
      BB.props({
        context: SectionService.getContextPrefilled(),
        team: TeamService.getContextTeam(),
        pitches: PitchService.getContextPitchesPrefilled(),
        feedbackCounts: PitchService.getContextFeedbackCounts(),
      })
        .then((r) => {
          this.loading = false;
          this.context = r.context.data;
          this.pitches = r.pitches.data;
          if (this.prototype) {
            this.pitchAssignments = this.context.prototypes;
          } else {
            this.pitchAssignments = this.context.pitches;
          }
          this.team = r.team.data;
          this.feedbackCounts = r.feedbackCounts.data;
          console.log("Feedback counts", this.feedbackCounts);

          _.each(this.pitchAssignments, (pa) => {
            pa.withinWindow = fs.withinWindow(pa.start, pa.end);
            if (this.team) {
              pa.pitch = _.find(this.pitches, {
                team_id: this.team.id,
                assignment_id: pa.id,
              });
              pa.feedbackCount =
                _.find(this.feedbackCounts, {
                  team_id: this.team.id,
                  assignment_id: pa.id,
                }) || 0;
            }

            ProgramService.getContextProgram()
              .then((r) => {
                if (this.prototype) {
                  this.instructions = r.data.prototype_config.upload_instructions;
                } else if (this.context.is_contest) {
                  this.instructions = r.data.contest_upload_config.instructions;
                } else {
                  this.instructions = r.data.upload_config.instructions;
                }
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to load program", e);
              });
          });
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          Notie.error("Failed to load pitches", e);
        });
    },

    chooseAssignment(assignment) {
      this.selectedAssignment = assignment;
    },

    openDeletePitchModal(pitch) {
      this.deletingPitch = pitch;
      this.deleteConfirm = "";
      this.deleteFeedbacks = false;
      this.$bvModal.show("deletePitchModal");
    },

    deletePitch(pitch) {
      PitchService.deletePitch(pitch.pitch.id)
        .then(() => {
          Notie.success(`Deleted pitch ${pitch.name}`);
          this.$bvModal.hide("deletePitchModal");
          if (this.deleteFeedbacks) {
            PitchService.deletePitchFeedbacks(this.team.id, pitch.id)
              .then(() => {
                Notie.success(`Deleted pitch ${pitch.name} feedback`);
                this.selectedAssignment = null;
                this.loadData();
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Deleted pitch but failed to delete feedback");
                this.selectedAssignment = null;
                this.loadData();
              });
          } else {
            this.selectedAssignment = null;
            this.loadData();
          }
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to delete pitch", e);
        });
    },

    sendingEvent(file, xhr, formData) {
      formData.append("userID", JSON.stringify([this.user.id]));
      formData.append("name", file.name);
      // debugger;
    },

    uploadError(file, err) {
      if (err == "Upload canceled.") {
        //Squelch this error, it occurs in the course of normal operation
        return;
      }
      PitchService.uploadFailure(this.uploadKeys);
      console.log({ "Dropzone error": err });
      Notie.error(`Failed to upload file '${file.name}'`, err);
    },

    uploadComplete(parts) {
      Notie.success(
        (this.prototype ? "Prototype" : "Pitch") + ` submitted`,
        `Assignment: "${this.selectedAssignment.name}"`
      );

      this.uploadKeys['parts'] = parts

      PitchService.uploadSuccess(this.team.id, this.selectedAssignment.id, this.uploadKeys);
      this.submitting = false;
      this.selectedAssignment = null;
      this.loadData();
    },

    removeIfUnsupported(files) {
      let supported = false;
      for (let file of files) {
        console.log("file.type: ", file.type);
        if (unsupportedMTs.includes(file.type)) {
          this.$refs.myVueDropzone.removeFile(file);
          Notie.error("Unsupported File Type");
        }
      }
      return supported;
    },

    getYouTubeID(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      console.log("URL", url);
      let match = url.match(regExp);
      console.log("MATCH", match);

      return match && match[2].length === 11 ? match[2] : null;
    },

    updateFile(file) {
      this.file = file
    },

    submit() {
      console.log("FILE", this.file)
      switch (this.uploadFrom) {
        case "computer":
          PitchService.initUpload({"fileName": this.file.name})
          .then((r) => {
            this.uploadKeys = {"uploadID":r.data.uploadID, "key":r.data.key}
            this.submitUpload(this.uploadKeys);
          })
          break;
        case "youtube":
          this.submitYoutube();
          break;
        default:
          Notie.error("Unsupported upload method");
      }
      this.submitDescription();
    },

    submitYoutube() {
      if (!this.youTubeID) {
        Notie.error("Can't submit YouTube video", "Invalid video ID");
        return;
      }

      PitchService.submitPitchYoutube(
        this.team.id,
        this.selectedAssignment.id,
        this.youTubeID
      )
        .then(() => {
          Notie.success(
            (this.prototype ? "Prototype" : "Pitch") + ` submitted`,
            `Assignment: "${this.selectedAssignment.name}"`
          );
          this.selectedAssignment = null;
          this.loadData();
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to submit pitch", e);
        });
    },

    submitDescription(){
      if (!this.descriptionText || this.descriptionText == "") {
        return;
      }

      PitchService.saveDescription(
        this.team.id,
        this.selectedAssignment.id,
        this.descriptionText
      )
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to add description", e);
        });
    },

    goBack() {
      if (this.selectedAssignment) {
        this.$nextTick(() => {
          this.selectedAssignment = null;
        });
      } else {
        this.$nextTick(() => {
          this.team = null;
        });
      }
    },

    toggleInstructions() {
      this.hideInstructions = !this.hideInstructions;
    },

    selectTeam(t) {
      this.team = t;
      _.each(this.pitchAssignments, (pa) => {
        pa.pitch = _.find(this.pitches, {
          team_id: this.team.id,
          assignment_id: pa.id,
        });
        pa.feedbackCount =
          _.find(this.feedbackCounts, {
            team_id: this.team.id,
            assignment_id: pa.id,
          }) || 0;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.youtube-url-entry {
  margin-left: auto;
  margin-right: auto;
  max-width: 650px;
  font-size: 24px;
}
.mzd-video {
  width: 100%;
}
.video-box {
  margin-top: 20px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  height: 315px;

  /*padding:80px;*/
  -webkit-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
  -moz-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
  box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
  background-color: white;
  color: black;
  font-family: "Times New Roman", Times, Georgia, serif;
}

.black-border {
  border: 2px solid rgb(128, 128, 128);
}

.btn-same-width {
  width: 120px;
}
</style>
